import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export type ShippingCarrier = 'self-shipping' | 'entrega99' | 'lalamove';

const CARRIER_API_PREFIX: Record<ShippingCarrier, string> = {
  'self-shipping': 'self-shippings/v1',
  'entrega99': 'entrega99/v1',
  'lalamove': 'lalamove/v1',
};

export interface IProofUploadResponse {
  uploadId: string;
}

@Injectable({ providedIn: 'root' })
export class ProofEvidenceService {
  private http = inject(HttpClient);

  private basePath(carrier: ShippingCarrier): string {
    return `/api/${CARRIER_API_PREFIX[carrier]}`;
  }

  uploadProof(
    carrier: ShippingCarrier,
    shippingReference: string,
    stopIndex: number,
    photo: File
  ): Observable<IProofUploadResponse> {
    const formData = new FormData();
    formData.append('photo', photo, photo.name);
    return this.http.post<IProofUploadResponse>(
      `${this.basePath(carrier)}/orders/${shippingReference}/stops/${stopIndex}/proof`,
      formData
    );
  }

  proofContentUrl(uploadId: string): string {
    return `/api/v1/proofs/uploads/${uploadId}/content`;
  }
}
